import Mask from './mask';
import Form from './form';
import axios from '../../../node_modules/axios';

class Budget {
  constructor() {
    const that = this;

    let budget = $('.js-budget'),
        budgetForm = $('.js-budget-form');

    if($(window).outerWidth() >= 768) {
      budget.css('height', budget.outerHeight());
    }

    $(document).on('resize', function(){
      if($(window).outerWidth() >= 768) {
        budget.css('height', budget.outerHeight());
      }
    });

    // Init wizardForm
    that.initWizardForm(budget, budgetForm);

    // Show/Hide Budget Form
    that.triggerBudget(budget);

    // Show/Hide Budget Category Input
    that.toggleBudgetCategoryInput();
  }

  initWizardForm(budget, budgetForm) {
    const that = this;

    $.validator.addMethod('phoneBR', function (value, element) {
      value = value.replace(/\D/g, '');
      return this.optional(element) || /[0-9]{10}/.test(value);
    }, 'Por favor, um telefone válido');

    budgetForm.validate({
      lang: 'pt_BR',
      rules: {
        phone: {
          required: true,
          phoneBR: true
        }
      },
      errorElement: 'small',
      errorClass: '-form-error',
      validClass: '-form-success',
      highlight: function(input, errorClass, validClass) {
        $(input).addClass(errorClass).removeClass(validClass);
        $(input.form).find('.form-group').addClass(errorClass);
      },
      unhighlight: function(input, errorClass, validClass) {
        $(input).removeClass(errorClass).addClass(validClass);
        $(input.form).find('.form-group').removeClass(errorClass);
      }
    });

    budgetForm.steps({
      headerTag: 'h4',
      bodyTag: 'fieldset',
      transitionEffect: 'fade',
      enablePagination: false,
      startIndex: 0,
      onInit: function (event, current) {
        budgetForm.steps('getStep', 0);

        new Mask();
        new Form();

        $('.form-actions .js-prev-step').addClass('sr-only');
        $('.form-actions .js-send-budget').addClass('sr-only');
      },
      onStepChanging: function (event, currentIndex, newIndex)
      {
        if (currentIndex > newIndex) {
          return true;
        }

        budgetForm.validate().settings.ignore = ':disabled,:hidden';
        return budgetForm.valid();
      },
      onStepChanged: function (event, current, next) {
        if(current == 0) {
          $('.form-actions .link, .form-actions .btn').removeClass('sr-only');
          $('.form-actions .js-prev-step').addClass('sr-only');
          $('.form-actions .js-send-budget').addClass('sr-only');
        } else {
          $('.form-actions .link, .form-actions .btn').removeClass('sr-only');
          $('.form-actions .js-close-budget').addClass('sr-only');
          $('.form-actions .js-send-budget').addClass('sr-only');
        }

        if(current == (budgetForm.find('.budget-step').length - 1)) {
          $('.form-actions .link, .form-actions .btn').removeClass('sr-only');
          $('.form-actions .js-close-budget').addClass('sr-only');
          $('.form-actions .js-next-step').addClass('sr-only');
        }
      },
      onFinishing: function (event, currentIndex)
      {
        let form = $(this);

        form.validate().settings.ignore = ':disabled';

        return budgetForm.valid();
      },
      onFinished: function (event, currentIndex)
      {
        let form = this;
        let formData = new FormData();

        for (let i = 0; i < form.length; ++i) {
          if (that.isCheckbox(form[i]) == false) {
            formData.append(form[i].name, form[i].value);
          } else {
            if (form[i].checked) {
              formData.append(form[i].name, form[i].value);
            }
          }
        }

        axios({
          method: 'post',
          url: form.action,
          data: formData
        })
        .then(response => {
          that.handleResponse(response.data, form, budget);
        }, error => {
          that.handleError(error.response.data, form);
        });
      }
    });

    $('.js-prev-step').on('click', function(e) {
      e.preventDefault();
      budgetForm.steps('previous');
    });

    $('.js-next-step').on('click', function(e) {
      e.preventDefault();
      budgetForm.steps('next');
    });

    $('.js-send-budget').on('click', function(e) {
      e.preventDefault();
      budgetForm.steps('finish');
    });
  }

  handleResponse(response, form, budget) {
    const that = this;

    let jForm = $(form);

    // Remove error class
    jForm.find('.form-group').removeClass('-form-error');
    jForm.find('.form-control').removeClass('-form-error');

    // Reset form
    jForm[0].reset();

    let budgetType = budget.data('budget-type');

    if(budgetType == 'gastronomy' ) {
      that.closeBudgetGastronomy(budget);
    } else if( budgetType == 'buffet' || budgetType == 'house' || budgetType == 'consulting' ) {
      that.closeBudgetDefault(budget);
    }

    budget.removeClass('-active');
  }

  handleError(error, form) {
    // Add error message
    $.each(error.data, function (key, value) {
      let input = form.find('.js-validate[name=' + key + ']').closest('.form-group');
          input.addClass('-form-error');
          input.find('.form-control').addClass('-form-error');
    });
  }

  triggerBudget(budget) {
    const that = this;

    $('.js-open-budget').on('click', function(e) {
      e.preventDefault();

      $('html, body').animate({
        scrollTop: budget.offset().top
      }, 400);

      let budgetType = budget.data('budget-type');

      if( budgetType == 'gastronomy' ) {
        that.openBudgetGastronomy(budget);
      } else if( budgetType == 'buffet' || budgetType == 'house' || budgetType == 'consulting' ) {
        that.openBudgeteDefault(budget);
      }

      budget.addClass('-active');
    });

    $('.js-close-budget').on('click', function(e) {
      e.preventDefault();

      let budgetType = budget.data('budget-type');

      if( budgetType == 'gastronomy' ) {
        that.closeBudgetGastronomy(budget);
      } else if( budgetType == 'buffet' || budgetType == 'house' || budgetType == 'consulting' ) {
        that.closeBudgetDefault(budget);
      }

      budget.removeClass('-active');
    });
  }

  openBudgetGastronomy(budget) {
    budget.find('.page-heading, .page-content').parent()
          .removeClass('col-sm-offset-6')
          .addClass('col-sm-offset-4');
  }

  openBudgeteDefault(budget) {
    budget.find('.page-heading').parent()
          .removeClass('col-sm-8 col-sm-offset-1 col-md-6 col-md-offset-6 col-lg-5')
          .addClass('col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-4 col-lg-7');

    budget.find('.page-content').parent()
          .removeClass('col-md-offset-6')
          .addClass('col-md-offset-4');
  }

  closeBudgetGastronomy(budget) {
    budget.find('.page-heading, .page-content').parent()
          .removeClass('col-sm-offset-4')
          .addClass('col-sm-offset-6');
  }

  closeBudgetDefault(budget) {
    budget.find('.page-heading').parent()
          .removeClass('col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-4 col-lg-7')
          .addClass('col-sm-8 col-sm-offset-1 col-md-6 col-md-offset-6 col-lg-5');

    budget.find('.page-content').parent()
          .removeClass('col-md-offset-4')
          .addClass('col-md-offset-6');
  }

  toggleBudgetCategoryInput() {
    let categorySelect = $('#event_category'),
        categoryInput = $('#event_category_details');

    categorySelect.on('change', function() {
      let currentOption = $(this).val();
      if (currentOption == 9) {
        categoryInput.parent().removeClass('-hidden');
        categoryInput.prop('disabled', false);
      } else {
        categoryInput.parent().addClass('-hidden');
        categoryInput.prop('disabled', true);
      }
    });
  }

  isCheckbox(element) {
    return element instanceof HTMLInputElement && element.getAttribute('type') == 'checkbox';
  }
}

export default Budget;
